
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kntxt",
      function () {
        return require("private-next-pages/kntxt.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kntxt"])
      });
    }
  